import { PageListCachedDataSource } from './BaseDataSources';
import { IDocumentType } from '../Interfaces';

export class DocumentTypeSource extends PageListCachedDataSource<IDocumentType> {
  /**
  * @param {boolean} isActive - An optional parameter for filtering active records.
  */
  public constructor(isActive?: boolean) {
    super('/datasource/documenttypes', { isActive });
  }
}